import { Tooltip } from '@mui/material';
import React from 'react';

const normalizePercentage = (percentage: number) => parseFloat(percentage.toFixed(1));

export function getClassificationText(percentage: number | null, labels?: Partial<Record<'critical' | 'bad' | 'fair' | 'good' | 'excellent', string>>): string {
    if (percentage === null) {
      return "";
    }

    const roundedPercentage = normalizePercentage(percentage);

    if (roundedPercentage >= 0 && roundedPercentage < 40) return labels?.critical || "Crítico";
    if (roundedPercentage >= 40 && roundedPercentage < 60) return labels?.bad || "Ruim";
    if (roundedPercentage >= 60 && roundedPercentage < 70) return labels?.fair || "Razoável";
    if (roundedPercentage >= 70 && roundedPercentage < 80) return labels?.good || "Bom";
    if (roundedPercentage >= 80 && roundedPercentage <= 100) return labels?.excellent || "Excelente";
    return "";
  };

export function Ball({ percentage }: { percentage: number | null }) {
    let background;
    if (percentage === null) {
      background = '#c9c9c9';
    } else {
      const roundedPercentage = normalizePercentage(percentage);
      if (roundedPercentage >= 0 && roundedPercentage < 40) {
        background = 'linear-gradient(315deg, #FD4659 0%, #FEA993 100%)';
      } else if (roundedPercentage >= 40 && roundedPercentage < 60) {
        background = 'linear-gradient(314deg, #FA7F63 4.99%, #FEE073 100%)';
      } else if (roundedPercentage >= 60 && roundedPercentage < 70) {
        background = 'linear-gradient(314deg, #FFDB23 2.1%, #FFF676 78.35%)';
      } else if (roundedPercentage >= 70 && roundedPercentage < 80) {
        background = 'linear-gradient(318deg, #24c58b 16.44%, #96ffa9 85.22%)';
      } else if (roundedPercentage >= 80 && roundedPercentage <= 100) {
        background = 'linear-gradient(318deg, #186d4c 16.44%, #0cc93c 85.22%)';
      }
    }
  
    return (
      <>
        <div style={{ width: '10px', height: '10px', borderRadius: '50%', background }} />
      </>
    
       
    );
  }
